// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ZoVw","footer":"ModalFilter_footer__7C8yL"};